import $ from 'jquery';

export default {
    show(el:string):Promise<void> {
        return new Promise((resolve) => {
            // @ts-ignore
            $(el).modal({
                backdrop: 'static',
                keyboard: false,
            });

            resolve();
        })        
    },
    hide(el:string):Promise<void> {
        return new Promise((resolve) => {
            // @ts-ignore
            $(el).modal('hide');

            resolve();
        })
    },
}
